import { render, staticRenderFns } from "./CMLocationCRUD.vue?vue&type=template&id=57ca920f&lang=pug"
import script from "./CMLocationCRUD.vue?vue&type=script&lang=js"
export * from "./CMLocationCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports